// src/utils/lote.js — id de uma rodada de envio em massa.
//
// Out/26 (Formulários PR 3). Cada rodada de envio em massa (lote do chat e
// "Enviar template" da tela de Contatos) manda o MESMO id em todos os
// POST /messages/send. É ele que agrupa, na aba Respostas, as respostas do
// formulário do botão por disparo. O servidor só aceita letras, números e
// hífen (o formato do UUID) — fora disso o envio vira "um a um".
export function novoLoteId() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch { /* contexto sem crypto */ }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
